module.exports = __webpack_public_path__ + "MuseoSans-500Italic.743475e83a8d323428db.ttf";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/MuseoSans-500Italic.ttf
// module id = ../../../../../src/assets/fonts/MuseoSans-500Italic.ttf
// module chunks = styles